import Vue from 'vue'
import api from '@/api'
import store from 'store'
import cookies from 'js-cookie'
import { add } from 'lodash'

export default {
  state: {
    roles: []
  },
  mutations: {
    SET_ROLES(state, data) {
      state.roles = data
    },
    ADD_ROLE(state, role) {
      // find existing role by name
      let existing = state.roles.find((r) => r.name === role.name)
      if (existing) {
        Object.assign(existing, role)
      } else {
        state.roles.push(role)
      }
    },
    UPDATE_ROLE(state, role) {
      let existing = state.roles.find((r) => r.id === role.id)
      if (existing) {
        Object.assign(existing, role)
      } else {
        state.roles.push(role)
      }
    },
    DELETE_ROLE(state, role) {
      let index = state.roles.findIndex((r) => r.id === role.id)
      if (index >= 0) {
        state.roles.splice(index, 1)
      }
    }
  },
  actions: {
    async loadRoles({ commit }) {
      let resp = await api.roles.getRoles()
      commit('SET_ROLES', resp.data)
    },
    async addRole({ commit }, role) {
      let resp = await api.roles.addRole(role)
      commit('ADD_ROLE', resp.data)
    },
    async updateRole({ commit }, role) {
      let resp = await api.roles.updateRole(role)
      commit('UPDATE_ROLE', resp.data)
    },
    async deleteRole({ commit }, id) {
      let resp = await api.roles.deleteRole(id)
      commit('DELETE_ROLE', resp.data)
    }
  },
  getters: {
    roles(state) {
      return state.roles
    },
    currentStationRoles(state) {
      let currentStationId = vuex.getters.currentStation?.id
      if (!currentStationId) return []
      const globalRoles = state.roles?.filter((r) => r.stationId === null) || []
      const stationRoles = state.roles?.filter((r) => r.stationId === currentStationId) || []

      return globalRoles.concat(stationRoles)
    }
  }
}
